import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouteConstants } from '../../constants/api-routes';
import { GetFriendliesForFRNRequest } from './models/get-friendlies-for-frns-request';
import { FRNResponse } from './models/frn-response';
import { ASRResponse } from './models/asr-response';
import { FrnEntitySearchRequest } from './models/frn-entity-search-request';
import { FrnEntitySearchResponse } from './models/frn-entity-search-response';
import { HasLicenseDataResponse } from './models/has-license-data-response';

@Injectable({
    providedIn: 'root',
})
export class ULSService {
    private readonly ulsApiRoute = ApiRouteConstants.ULS;

    constructor(private readonly http: HttpClient) {}

    getFriendliesForFRNs(
        request: GetFriendliesForFRNRequest,
    ): Observable<FRNResponse[]> {
        return this.http.post<FRNResponse[]>(
            this.ulsApiRoute.friendliesForFRNs,
            request,
        );
    }

    hasLicenseData(callSign: string): Observable<HasLicenseDataResponse> {
        const url = `${this.ulsApiRoute.hasLicenseData}?callSign=${encodeURIComponent(callSign)}`;
        return this.http.get<HasLicenseDataResponse>(url);
    }

    getASRLocation(asrValue: number): Observable<ASRResponse> {
        const url = `${this.ulsApiRoute.asrLocation}?asrNumber=${asrValue}`;
        return this.http.get<ASRResponse>(url);
    }

    searchEntities(
        request: FrnEntitySearchRequest,
    ): Observable<FrnEntitySearchResponse[]> {
        return this.http.post<FrnEntitySearchResponse[]>(
            this.ulsApiRoute.searchEntities,
            request,
        );
    }
}
